<ng-container *ngIf="windowHash && !task">
  <sub-header *ngIf="!documentIdParam && !showExpanded" [isModal]="true" [includeContextHelp]="true"
    [windowHash]="windowHash">
  </sub-header>
  <p-scrollPanel [style]="{width: '100%', height: 'calc(100vh - 86px)'}" styleClass="custombar1" *ngIf="isDocLoaded()">
    <!--  m-t-lg en modal para que los botones no pisen el contenido -->
    <div class="m-t-xs" *ngIf="isDocLoaded()">
      <ng-container *ngTemplateOutlet="documentTemplate"></ng-container>
    </div>
  </p-scrollPanel>
</ng-container>
<div class="wrapper wrapper-content pb-0" *ngIf="!windowHash && !task && isDocLoaded()">
  <ng-container *ngTemplateOutlet="documentTemplate"></ng-container>
</div>
<div *ngIf=" task && isDocLoaded()">
  <ng-container *ngTemplateOutlet="documentTemplate"></ng-container>
</div>
<ng-template #documentTemplate>
  <!-- INFORMACION DEL EXPEDIENTE -->
  <div class="container-fluid ui-fluid  m-t-xs ">
    <div *ngIf="this.isSigningCall()" class="mb-2">
      <div class="col-12 p-0 mb-2 text-right" *ngIf="this.task.work?.documents?.length > 1">
        <span class="mr-3">Documento: {{documentIndex + 1}} de {{this.task.work?.documents?.length}}</span>
        <span>
          <button (click)="previousDocument()" class="btn btn-outline-secondary ml-2"
            *ngIf="this.task?.work?.documents?.length > 1 && this.documentIndex > 0"><i class="fas fa-chevron-left"></i>
            {{'General.previous' | translate}}</button>
          <button (click)="nextDocument()" class="btn btn-outline-secondary ml-2"
            *ngIf="this.task?.work?.documents?.length > 1 && this.documentIndex < this.task?.work?.documents?.length - 1"><i
              class="fas fa-chevron-right"></i> {{'General.next' | translate}}</button>
        </span>
      </div>
      <div class="col-12 p-0" *ngIf="this.task?.work?.documents?.length > 1  && getPendigSignatureDocs() > 0">
        <div class="alert alert-info m-b-xs text-ellipsis">
          <i class="fas fa-1-5x fa-info-circle float-left mr-2" aria-hidden="true"></i>
          {{'DocumentView.pendingSignDocuments' | translate: { num: getPendigSignatureDocs()} }}
        </div>
      </div>
      <div class="col-12 p-0">
        <label for="COMMENT_TXTAREA" id="commentsCtrl_label">{{'DocumentView.comment' | translate }} </label>
        <p-dropdown *ngIf="comments && comments.length > 1" id="commentsCtrl" [options]="comments"
          [(ngModel)]="selectedComment" (onChange)="selectComment($event.value)" dataKey="id">
          <ng-template let-comment pTemplate="selectedItem">
            <span>
              <i style="font-size:1.5em;" class="fas fa-user-tie" aria-hidden="true"
                *ngIf="comment.value.origin == 'inbox'"></i>
              <i style="font-size:1.5em;" class="fas fa-user-friends" aria-hidden="true"
                *ngIf="comment.value.origin == 'substitution'"></i>
              <i style="font-size:1.5em;" class="fas fa-comment" aria-hidden="true"
                *ngIf="comment.value.origin == 'general'"></i>
            </span>
            <span class="ml-2">{{comment.label}}</span>
          </ng-template>
          <ng-template let-comment pTemplate="item">
            <span>
              <i style="font-size:1.5em;" class="fas fa-user-tie" aria-hidden="true"
                *ngIf="comment.value.origin == 'inbox'"></i>
              <i style="font-size:1.5em;" class="fas fa-user-friends" aria-hidden="true"
                *ngIf="comment.value.origin == 'substitution'"></i>
              <i style="font-size:1.5em;" class="fas fa-comment" aria-hidden="true"
                *ngIf="comment.value.origin == 'general'"></i>
            </span>
            <span class="ml-2">{{comment.label}}</span>
          </ng-template>
        </p-dropdown>
        <textarea [maxlength]="maxLengthCommentSign" pInputTextarea id="COMMENT_TXTAREA" name="COMMENT_TXTAREA"
          type="text" [(ngModel)]="comment" rows="3" class="plForm-element mt-1" pInputTextarea></textarea>
      </div>
    </div>
    <div class="row" *ngIf="this.windowHash">
      <div class=" alert alert-warning col-12" role="alert" *ngIf="documentVersionId">
        <i class="fas fa-lg fa-info-circle float-left mr-2"></i> {{'DocumentView.versionTitle' | translate: {
        documentVersionId:documentVersionId } }}
      </div>
    </div>
    <div class="row">
      <!-- ZONA DE DOCUMENTO -->
      <div [ngClass]="getClassDocExpanded()" *ngIf="this.currentFile; else elseBlockNonExistingFile">
        <div class="w-100">
          <!-- RENDERIZAR DOCUMENTO PDF -->
          <div *ngIf="this.currentFile && this.isPdf ()">
            <!-- <p-panel class="panel-no-padding">
                            <p-header>
                                {{this.currentFile?.name}}
                            </p-header> -->
            <filePDFViewer #viewer [currentFile]="this.currentFile" [showZoom]="true" [showPages]="true"
              [showToolbar]="true" [showRotation]="true" [showAllPagesDocument]="false">
            </filePDFViewer>
            <!-- </p-panel> -->
          </div>
          <!-- RENDERIZAR DOCUMENTO NO PDF -->
          <p-panel *ngIf="this.currentFile && !this.isPdf()" styleClass="docViewPanel">
            <!-- CABECERA DE DOCUMENTO -->
            <ng-template pTemplate="header">
              <span class="leyenda">{{this.currentFile.name}}</span>
              <!--<div class="ibox-tools float-right">
                <div
                  [ngSwitch]="this.currentFile.name.toUpperCase().substring(this.currentFile.name.lastIndexOf('.')+1)"
                  class="p-5">
                  <div class="icon" *ngSwitchCase="'PDF'">
                    <a class="collapse-link" (click)="downloadFile(this.currentFile)" target="newwwindoe">
                      <i class="fas fa-download"></i>
                    </a>
                    <a class="close-link" (click)="printFile(this.currentFile)">
                      <i class="fa fa-print"></i>
                    </a>
                  </div>
                </div>
              </div>-->
            </ng-template>
            <div [ngSwitch]="this.currentFile.name.toUpperCase().substring(this.currentFile.name.lastIndexOf('.')+1)">
              <div class="icon" *ngSwitchCase="'PDF'">
                <i class="fas fa-file-pdf fa-5x text-doc"></i>
              </div>
              <!--div class="icon" *ngSwitchCase="'XML'">
                    <i class="fas fa-file-code fa-5x text-doc"></i>
                  </div>
                  <div class="icon" *ngSwitchCase="'DOC'">
                    <i class="fas fa-file-word fa-5x text-doc"></i>
                  </div>
                  <div class="icon" *ngSwitchCase="'DOCX'">
                    <i class="fas fa-file-word fa-5x text-doc"></i>
                  </div-->
              <div *ngSwitchCase="htmlviewerActive ? 'HTML' : 'NULL'" [innerHtml]="fileHtmlContent"
                class="cleanslate docHtmlPlyca"></div>
              <div class="p-5 text-center" *ngSwitchDefault>
                <!--i class="fas fa-file-code fa-5x text-doc"></i-->
                <button (click)="downloadFile(this.currentFile)" class="btn btn-white d-inline-block w-100 "><i
                    class="fas fa-download fa-5x text-doc"></i> </button>
                <span class="text-doc d-inline-block w-100">{{ 'FilePDFViewer.download' | translate }}</span>
              </div>
            </div>
          </p-panel>
        </div>
      </div>
      <!-- FIN ZONA DOCUMENTO -->
      <!-- ACCIONES SOBRE EL DOCUMENTO -->
      <div [ngClass]="getStyleInfo()">
        <p-accordion [multiple]="true" class="file-info">
          <p-accordionTab header="{{ 'DocumentView.info' | translate }}" [selected]="true">
            <div *ngIf="this.currentFile">
              <dl class="dl-vertical">
                <dt>{{ 'DocumentView.name' | translate }}</dt>
                <dd>{{this.currentFile?.name}}</dd>
                <dt>{{ 'DocumentView.description' | translate }}</dt>
                <dd class="text-break">{{this.document?.name}}</dd>
                <dt>{{ 'General.user' | translate }}</dt>
                <dd>
                  <user [user]="this.document?.user"></user>
                </dd>
                <dt>{{ 'DocumentView.date.created' | translate }}</dt>
                <dd>{{ this.document?.creationDate|date:'dd-MM-yyyy HH:mm'}}</dd>
                <dt>{{ 'DocumentView.state' | translate }}</dt>
                <dd>{{ this.document?.currentState?.type?.description}}</dd>
                <dd *ngIf="this.document?.currentState?.date"> {{ this.document.currentState.date|date: 'dd-MM-yyyy
                  HH:mm'}}</dd>
                <dt>{{ 'DocumentView.version' | translate }}</dt>
                <dd>{{ getProcedureIdentifier(this.documentVersion?.identifier)}}</dd>
                <dt>{{ 'DocumentView.type' | translate }}</dt>
                <dd> {{ ((this.document?.type) ? this.translateService.instant('Documents.types.' + this.document.type)
                  : '')}} </dd>
                <div *ngIf="this.document?.locale  && this.document?.locale !== this.document?.entity?.division?.project?.locale">
                  <dt>{{ 'Languages.language' | translate }}</dt>
                  <dd>
                    {{ ('Languages.' + this.document.locale) | translate }}
                  </dd>
                </div>
                <div *ngIf="this.document?.confidentialityLevel">
                  <dt>{{ 'DocumentView.confidentialityLevel' | translate }}</dt>
                  <dd> {{ this.translateService.instant('DocumentView.confidentiality.' +
                    this.document.confidentialityLevel)}}
                  </dd>
                </div>
              </dl>
            </div>
          </p-accordionTab>
          <p-accordionTab header="{{ 'DocumentView.files' | translate }}" [selected]="true">
            <ul class="list-unstyled project-files">
              <li *ngIf="ca_files && ca_files.length > 0 && !adaptationAymadEnabled" class="mt-2">
                <b>{{ 'DocumentView.document.type.CA' | translate }}</b>
              </li>
              <li *ngIf="ca_files && ca_files.length > 0 && adaptationAymadEnabled" class="mt-2">
                <b>{{ 'DocumentView.document.type.CSP' | translate }}</b>
              </li>
              <li *ngFor="let file of ca_files">
                <a (click)="loadFile(file)" class="doc-name ml-0">
                  <i class="far fa-file-alt fa-lg  text-default"></i>
                  <span *ngIf="this.currentFile.identifier === file.identifier"><b><i> {{file.name}}</i></b></span>
                  <span *ngIf="this.currentFile.identifier !== file.identifier"> {{file.name}}</span></a>
              </li>
              <!-- <li *ngIf="oe_files.length > 0" class="divider"  role="separator" ></li> -->
              <li *ngIf="oe_files && oe_files.length > 0 && !adaptationAymadEnabled" class="mt-2">
                <b>{{ 'DocumentView.document.type.OE' | translate }}</b>
              </li>
              <li *ngIf="oe_files && oe_files.length > 0 && adaptationAymadEnabled" class="mt-2">
                <b>{{ 'DocumentView.document.type.FD' | translate }}</b>
              </li>
              <li *ngFor="let file of oe_files">
                <a (click)="loadFile(file)" class="doc-name ml-0">
                  <i class="far fa-file-alt fa-lg  text-default"></i>
                  <span *ngIf="this.currentFile.identifier === file.identifier"><b><i> {{file.name}}</i></b></span>
                  <span *ngIf="this.currentFile.identifier !== file.identifier"> {{file.name}}</span></a>
              </li>
              <!-- <li *ngIf="usr_files.length > 0" class="divider"  role="separator" ></li> -->
              <li *ngIf="usr_files && usr_files.length > 0 && !adaptationAymadEnabled" class="mt-2">
                <b>{{ 'General.user' | translate }}</b>
              </li>
              <li *ngIf="usr_files && usr_files.length > 0 && adaptationAymadEnabled" class="mt-2">
                <b>{{ 'DocumentView.document.type.FE' | translate }}</b>
              </li>
              <li *ngFor="let file of usr_files">
                <a (click)="loadFile(file)" class="doc-name ml-0">
                  <i class="far fa-file-alt fa-lg  text-default"></i>
                  <span *ngIf="this.currentFile.identifier === file.identifier"><b><i> {{file.name}}</i></b></span>
                  <span *ngIf="this.currentFile.identifier !== file.identifier"> {{file.name}}</span></a>
              </li>
              <ng-container *ngIf="userService.hasRoles(systemFilesVisible)">
                <!-- <li *ngIf="sys_files.length > 0" class="divider"  role="separator" ></li> -->
                <li *ngIf="sys_files && sys_files.length > 0" class="mt-1">
                  <b>{{ 'DocumentView.document.type.SIS' | translate }}</b>
                </li>
                <li *ngFor="let file of sys_files">
                  <a (click)="loadFile(file)" class="doc-name ml-0">
                    <i class="far fa-file-alt fa-lg text-default"></i>
                    <span *ngIf="this.currentFile.identifier === file.identifier"><b><i> {{file.name}}</i></b></span>
                    <span *ngIf="this.currentFile.identifier !== file.identifier"> {{file.name}}</span></a>
                </li>
              </ng-container>
            </ul>
          </p-accordionTab>
          <!-- FIRMAS DEL DOCUMENTO -->
          <p-accordionTab header="{{ 'DocumentView.signs' | translate }}"
            *ngIf="this.currentFile && this.currentFile.signatures && this.currentFile.signatures.length > 0"
            [selected]="true">
            <ul class="list-unstyled project-files">
              <li class="documetfile-detail d-inline-block w-100"
                *ngFor="let signature of signaturesPlainList; let o = index">
                <a (click)="validateSignDocument(signature,this.currentFile)" class="d-inline">
                  <img alt="image" class="pr-1 align-top "
                    src="assets/img/{{(signature.handWritten) ? 'CERESManuscrita.gif' : 'CERES.gif'}}"
                    style="width: 20px;" />
                  <span class="d-inline-block"><strong>{{(signature.handWritten) ?
                      signature.supportUser?.person?.fullName : signature.signer}}</strong></span>
                  <ul>
                    <li *ngIf="signature.accountingUser?.identifier" class="documetfile-detail row">
                      <span class="d-inline-block">
                        <small class="text-muted"><strong>{{ 'General.user' | translate }} </strong></small>
                        <small class="text-muted">{{signature.accountingUser.identifier}}</small>
                      </span>
                    </li>
                    <li *ngIf="signature.date" class="documetfile-detail row">
                      <span class="d-inline-block">
                        <small class="text-muted"><strong>{{ 'Signature.Details.Date' | translate }} </strong></small>
                        <small class="text-muted">{{ signature.date |date:'dd-MM-yyyy HH:mm'}}</small>
                      </span>
                    </li>
                    <li *ngIf="signature.position" class="documetfile-detail row">
                      <span class="d-inline-block">
                        <small class="text-muted"><strong>{{ 'Signature.Details.Position' | translate }}
                          </strong></small>
                        <small class="text-muted">{{signature.position}}</small>
                      </span>
                    </li>
                    <li *ngIf="signature.comment" class="documetfile-detail row">
                      <span class="d-inline-block">
                        <small class="text-muted"><strong>{{ 'Signature.Details.Comment' | translate }}
                          </strong></small>
                        <small *ngIf="signature.comment" class="text-muted text-break">{{signature.comment}}</small>
                        <small *ngIf="!signature.comment" class="text-muted">{{signature.remarks}}</small>
                      </span>
                    </li>
                  </ul>
                </a>

              </li>
            </ul>
          </p-accordionTab>
          <!-- ESTADOS DEL DOCUMENTO -->
          <p-accordionTab header="{{ 'DocumentView.states' | translate }}" [selected]="true">
            <ul class="list-unstyled project-files">
              <li>
                <a (click)="viewHistory(this.document.identifier)">
                  <i class="fa fa-lg fa-history" aria-hidden="true"></i> {{ 'DocumentView.history' | translate }}</a>
              </li>
              <li *ngIf="this.document?.hasRelatedDocuments">
                <a (click)="searchDocuments()">
                  <i class="fas fa-lg fa-exchange-alt" aria-hidden="true"></i> {{ 'DocumentView.relatedDocuments' |
                  translate }}</a>
              </li>
            </ul>
          </p-accordionTab>
        </p-accordion>
      </div>
    </div>
  </div>
</ng-template>
<ng-template #elseBlockNonExistingFile>
  <div class="col-12 col-sm-9 ">
    <div class="alert alert-info m-b-xs text-ellipsis col-12">
      <span>
        <i class="fas fa-1-5x fa-info-circle m-r-md" aria-hidden="true"></i> {{ 'DocumentView.no.results.attachments' |
        translate }}</span>
    </div>
  </div>
</ng-template>